export default "__VITE_ASSET__CRgTYBjW__"